import { useEffect } from 'react';

import { joinRoom, leaveRoom, socket } from '@mint-sdk/api-media-plan/socket';
import { getRouteApi } from '@mint/routing';

import { useChosenLevel } from '../useChosenLevel.js';
import { useRefreshOnReconnect } from './useRefreshOnReconnect.js';
import { useSocketEvents } from './useSocketEvents.js';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

const handleJoin = (params: Parameters<typeof joinRoom>[0]) => {
  const client = socket.getClient();
  const join = () => joinRoom(params);

  if (client.connected) join();
  client.on('connect', join);

  return () => {
    client.off('connect', join);
    leaveRoom(params);
  };
};

export const usePlanningSocket = () => {
  const { level, id } = useChosenLevel();
  const { mediaPlan: planMediaDataId } = routerApi.useSearch();

  // Registering events
  useSocketEvents();

  // refetch all data in background in case internet lost or socket disconnected
  useRefreshOnReconnect();

  // General room: rejoin on (re)connect and when planMediaDataId changes
  useEffect(() => {
    if (!planMediaDataId) return;

    return handleJoin({ room: 'general', entityId: planMediaDataId });
  }, [planMediaDataId]);

  // Level room: rejoin on (re)connect and when level/id change
  useEffect(() => {
    if (!level || !id) return;

    return handleJoin({ room: level, entityId: id });
  }, [level, id]);
};
